/* Sound and vibration for the rest timer. One shared AudioContext, created
 * or resumed inside the Done tap: browsers (iOS above all) only allow audio
 * that a user gesture unlocked. Every call is best effort and silent when the
 * device can't do it (no Web Audio; navigator.vibrate does not exist on iOS).
 *
 * navigator.audioSession.type is left alone on purpose: 'playback' would make
 * the beeps ignore the silent switch, but it also pauses Mo's music on every
 * rest. The default mixes with music, so with headphones in he hears both. */

let ctx = null;

/* Call from a click/tap handler. */
export function unlockAudio() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!ctx) ctx = new AC();
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    // iOS only counts a sound started inside the gesture: play a silent one.
    tone(440, 0, 0.01, 0);
  } catch {}
}

function tone(freq, at, dur, volume) {
  if (!ctx || ctx.state === 'closed') return;
  const t0 = ctx.currentTime + at;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  // Short ramps instead of a hard on/off, which clicks.
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(volume, t0 + 0.01);
  gain.gain.setValueAtTime(volume, t0 + Math.max(0.01, dur - 0.02));
  gain.gain.linearRampToValueAtTime(0, t0 + dur);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
}

function vibrate(pattern) {
  try { if (typeof navigator !== 'undefined' && navigator.vibrate) navigator.vibrate(pattern); } catch {}
}

/* T-10: a soft tick and a short buzz. */
export function warnAlert() {
  try { tone(1320, 0, 0.05, 0.12); } catch {}
  vibrate(60);
}

/* 0: three short 880 Hz beeps and three long buzzes. */
export function goAlert() {
  try { [0, 0.25, 0.5].forEach(at => tone(880, at, 0.15, 0.35)); } catch {}
  vibrate([300, 120, 300, 120, 300]);
}
